"use strict";
import createLegacyHistory from "../util/legacy_history";
import locationDescriptor from "../util/location_descriptor";
const history = createLegacyHistory("/app");
export default history;
export { locationDescriptor };
export function push(path, query = null, state = null) {
  history.push(locationDescriptor(path, query, state));
}
export function replace(path, query = null, state = null) {
  history.replace(locationDescriptor(path, query, state));
}
